<template>
  <el-menu
    :disabled="disabled"
    class="account-settings-navigation"
    :default-active="$route.path"
    @item-click="emitCloseEvent"
  >
    <el-menu-item
      :disabled="disabled"
      index="/account-settings/my-profile"
      @click="navigate"
    >
      <i class="ib-icon ib-icon-user h4 mr-2" />
      <span>{{ $t('settings.myProfile') }}</span>
    </el-menu-item>

    <el-menu-item
      v-if="!whitelabelEnabled"
      :disabled="disabled"
      index="/payment"
      @click="navigate"
    >
      <i class="ib-icon ib-icon-double-up h4 mr-2" />
      <span>{{ $t('settings.plansAndUpgrades') }}</span>
    </el-menu-item>

    <el-menu-item
      :disabled="disabled"

      index="/users"
      @click="navigate"
    >
      <i class="ib-icon ib-icon-team h4 mr-2" />
      <span>{{ $t('settings.users') }}</span>
    </el-menu-item>

    <el-menu-item
      :disabled="disabled"

      index="/idea-collection"
      @click="navigate"
    >
      <i class="ib-icon ib-icon-book-stack h4 mr-2" />
      <span>{{ $t('sidebar.ideaCollection') }}</span>
    </el-menu-item>

    <el-menu-item
      v-if="!whitelabelEnabled"
      :disabled="disabled"
      @click="$router.push({name: 'billing'})"
    >
      <i class="ib-icon ib-icon-activity-history h4 mr-2" />
      <span>{{ $t('settings.paymentHistory') }}</span>
    </el-menu-item>

    <el-menu-item
      v-if="!whitelabelEnabled"
      :disabled="disabled"
      index="/ai-assistance"
      @click="navigate"
    >
      <i class="ib-icon ib-icon-magic-2 h4 mr-2" />
      <span>{{ $t('aiAssistancePage.title') }}</span>
    </el-menu-item>

    <!--    <el-menu-item-->
    <!--      v-if="$store.state.user.subscription.update_url"-->
    <!--      @click="setDialogChangeBillingState(true)"-->
    <!--    >-->
    <!--      <i class="ib-icon ib-icon-currency-exchange h4 mr-2" />-->
    <!--      <span>{{ $t('settings.changeBilling') }}</span>-->
    <!--    </el-menu-item>-->

    <el-menu-item @click="setDialogLogoutState(true)">
      <i class="ib-icon ib-icon-export h4 mr-2" />
      <span>{{ $t('settings.logOut') }}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AccountSettingsMenu',

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('appSettings', ['whitelabelEnabled'])
  },

  methods: {
    ...mapMutations('ui', [
      'setDialogPaymentHistoryState',
      'setDialogLogoutState',
      'setDialogChangeBillingState'
    ]),

    navigate (event) {
      if (this.$route.path !== event.index) {
        this.$router.push(event.index)
      }
    },

    emitCloseEvent () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.account-settings-navigation {
  ::v-deep {
    .el-menu-item {
      font-family: $outfit-regular;
      color: rgba(41, 47, 77, 0.8);
      span {
        font-size: 15px;
      }
      //&.is-active {
      //  color: $color-royal-blue;
      //  background-color: $color-blue-hover;
      //}
    }
  }
}
</style>
